// extracted by mini-css-extract-plugin
export default {"asideCards":"AsideCards_asideCards__b0sgT","asideCards__hr":"AsideCards_asideCards__hr__jw9QP","asideCards__p":"AsideCards_asideCards__p__TOa0G"};